import React from 'react';

import { ToastProvider } from './toast';
import { LoaderProvider } from './loader';

const AppProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <LoaderProvider>
    <ToastProvider>{children}</ToastProvider>
  </LoaderProvider>
);

export default AppProvider;
